var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flag is-cover-image m-r-s is-inline-block",style:(_vm.backgroundImageStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }